import _ from 'lodash';
import React from 'react';

import { FormLabel } from '../_ui/forms.component';
import { IntlMsg } from '../IntlMsg/intl-msg.component';

interface IFormikFieldLabel {
  label?: any;
  htmlFor: string;
  hasError?: boolean;
}

export const FormikFieldLabel: React.FC<IFormikFieldLabel> = ({ label, htmlFor, hasError }) => {
  if (!label) {
    return null;
  }
  if (label.id) {
    return <FormLabel htmlFor={htmlFor} $hasError={hasError}><IntlMsg {...label} /></FormLabel>;
  }
  if (_.isString(label)) {
    return <FormLabel htmlFor={htmlFor} $hasError={hasError}>{label}</FormLabel>;
  }
  return label;
};
